<template>
    <div id="navigation-bgc" class="phone-class">
        <div class="navigation-container phone-class">
            <div id="navigation" class="phone-class" :class="isOpen || isBgc ? 'bgc-white' : ''">
                <!-- Logo -->
                <div class="navigation-logo">
                    <a class="navigation-router" @click="onRouter('/')">
                        <div v-if="!isOpen && !isBgc" id="logo-img1" class=""></div>
                        <div v-else id="logo-img2"></div>
                    </a>
                </div>
                <!-- 导航项 -->
                <div class="navigation-column">
                    <div class="navigation-item item-left current" @mouseenter="navigationMouseenter(1)" @mouseleave="navigationMouseleave(1)">
                        <a class="navigation-router item" @click="onRouter('/')">首页</a>
                    </div>
                    <div class="navigation-item item-left" @mouseenter="navigationMouseenter(2)" @mouseleave="navigationMouseleave(2)">
                        <a class="navigation-router item" @click="onRouter('/gsxw?subNavNumber=1')">公司新闻</a>
                    </div>
                    <div class="navigation-item item-left" @mouseenter="navigationMouseenter(3)" @mouseleave="navigationMouseleave(3)">
                        <a class="navigation-router item" @click="onRouter('/ncpxx?subNavNumber=1')">农产品信息</a>
                    </div>
                    <div class="navigation-item item-left" @mouseenter="navigationMouseenter(4)" @mouseleave="navigationMouseleave(4)">
                        <a class="navigation-router item" @click="onRouter('/cybj?subNavNumber=1')">产业布局</a>
                    </div>
                    <div class="navigation-item item-left" @mouseenter="navigationMouseenter(5)" @mouseleave="navigationMouseleave(5)">
                        <a class="navigation-router item" @click="onRouter('/tzzgx?subNavNumber=1')">投资者关系</a>
                    </div>
                    <div class="navigation-item item-left" @mouseenter="navigationMouseenter(6)" @mouseleave="navigationMouseleave(6)">
                        <a class="navigation-router item" @click="onRouter('/ztb?subNavNumber=1')">招投标</a>
                    </div>
                    <div class="navigation-item item-left" @mouseenter="navigationMouseenter(7)" @mouseleave="navigationMouseleave(7)">
                        <a class="navigation-router item" @click="onRouter('/gydr?subNavNumber=1')">关于东日</a>
                    </div>
                    <span class="navigation-span"></span>
                    <div class="nav-search" @mouseenter="searchMouseout()"  @mouseleave="navigationMouseleave()">
                        <input class="nav-search-input" v-model="keyWords" @keyup.enter="onSearch()" type="text" placeholder="请输入关键字">
                        <div class="nav-search-icon">
                            <i class="search-icon iconfont icon-sousuo" @click="onSearch()"></i>
                        </div>
                    </div>
                </div>
                <!-- 导航线 -->
                <div id="navigation-line" class="navigation-line" style="left: 546px;"></div>
                <!-- 手机 -->
                <div id="navigation-drop-down" class="navigation-drop-down" @click="onOpenClose()">
                    <span v-if="!isOpen" id="drop-down-open" class="drop-down-open">
                        <i class="iconfont icon-goutongye_santiaogang_tiaozhuanxuanzehaizi" style="color: #7D1118"></i>
                    </span>
                    <span v-else id="drop-down-close" class="drop-down-close" style="color: #7D1118;display:block">
                        <i class="iconfont icon-cuowu"></i>
                    </span>
                </div>
                <!-- 手机导航 -->
                <div id="navigation-external" class="navigation-external phone-class">
                    <div id="navigation-container" class="navigation-container phone-class">
                        <ul>
                            <li>
                                <a class="navigation-router" @click="onRouter('/')">首页</a>
                            </li>
                            <li>
                                <a class="navigation-router" @click="onRouter('/gsxw?subNavNumber=1')">公司新闻</a>
                            </li>
                            <li>
                                <a class="navigation-router" @click="onRouter('/ncpxx?subNavNumber=1')">农产品信息</a>
                            </li>
                            <li>
                                <a class="navigation-router" @click="onRouter('/cybj?subNavNumber=1')">产业布局</a>
                            </li>
                            <li>
                                <a class="navigation-router" @click="onRouter('/tzzgx?subNavNumber=1')">投资者关系</a>
                            </li>
                            <li>
                                <a class="navigation-router" @click="onRouter('/ztb?subNavNumber=1')">招投标</a>
                            </li>
                            <li>
                                <a class="navigation-router" @click="onRouter('/gydr?subNavNumber=1')">关于东日</a>
                            </li>
                        </ul>
                        <img class="sjdh1" src="../assets/navigation/sjdh1.png" alt="">
                        <img class="sjdh2" src="../assets/navigation/sjdh2.png" alt="">
                        <img class="sjdh3" src="../assets/navigation/sjdh3.png" alt="">
                        <img class="sjdh4" src="../assets/navigation/sjdh4.png" alt="">
                    </div>
                </div>
            </div>
        </div>
        <a href="JavaScript:;" id="open-siteMap" class="open-siteMap" @click="opensitemap">
            <i class="iconfont icon-caidan-dakai"></i>
        </a>
    </div>
</template>

<script>
import router from '@/router';
export default {
    props: {
        navigationLineLeft: String,
    },
    data() {
        return {
            keyWords: null,
            isOpen: false,
            isCloseOpen: true,
            isBgc: false,
        };
    },
    created(){
        window.addEventListener("scroll", this.handY, false);
        setTimeout(()=>{
            this.navigationMouseleave()
        },100)
    },
    methods: {
        onSearch(){
            if(!this.keyWords)return
            this.onRouter('/search?keyWords=' + this.keyWords)
        },
        onRouter(url){
            router.push(url)
            setTimeout(()=>{
                window.location.reload()
            },100)
        },
        // 滚动导航条背景过渡变色
        handY() {
            let scrollTop = document.documentElement.scrollTop;
            let Navigation = document.getElementById('navigation-bgc');
            let LogoImg1 = document.getElementById('logo-img1');
            let LogoImg2 = document.getElementById('logo-img2');
            let NavigationDropDown = document.getElementById('navigation-drop-down');
            // 设置主导航背景颜色
            if (scrollTop > 0 && scrollTop <= 50) {
                Navigation.style.backgroundColor = "rgba(255,255,255,0)";
            }
            if (scrollTop > 50 && scrollTop <= 100) {
                Navigation.style.backgroundColor = "rgba(255,255,255,0.1)";
            }
            if (scrollTop > 100 && scrollTop <= 150) {
                Navigation.style.backgroundColor = "rgba(255,255,255,0.2)";
            }
            if (scrollTop > 150 && scrollTop <= 200) {
                Navigation.style.backgroundColor = "rgba(255,255,255,0.3)";
            }
            if (scrollTop > 200 && scrollTop <= 250) {
                Navigation.style.backgroundColor = "rgba(255,255,255,0.4)";
            }
            if (scrollTop > 250 && scrollTop <= 300) {
                Navigation.style.backgroundColor = "rgba(255,255,255,0.5)";
            }
            if (scrollTop > 300 && scrollTop <= 350) {
                Navigation.style.backgroundColor = "rgba(255,255,255,0.6)";
            }
            if (scrollTop > 350 && scrollTop <= 400) {
                Navigation.style.backgroundColor = "rgba(255,255,255,0.7)";
            }
            if (scrollTop > 400 && scrollTop <= 450) {
                Navigation.style.backgroundColor = "rgba(255,255,255,0.8)";
            }
            if (scrollTop > 450 && scrollTop <= 500) {
                Navigation.style.backgroundColor = "rgba(255,255,255, 0.9)";
            }
            if (scrollTop > 500) {
                Navigation.style.backgroundColor = "rgba(255,255,255, 1)";
            }
            // 设置logo和手机导航开关
            if (scrollTop < 420) {
                this.isBgc = false
                // LogoImg1.className = '';
                // LogoImg2.className = 'no-display';
                // NavigationDropDown.style.color = "#fff";
            } else {
                this.isBgc = true
                // LogoImg1.className = 'no-display';
                // LogoImg2.className = '';
                // NavigationDropDown.style.color = "rgb(0,0,0)"
            }
            // 关闭手机导航
            if(this.isCloseOpen && this.isOpen){
                this.onOpenClose()
                this.isCloseOpen = false
            }
        },
        // 导航线滑动
        navigationMouseenter(idx){
            let NavigationLine = document.getElementById('navigation-line');
            switch ('item'+idx) {
                case 'item1': NavigationLine.style.left = '535px'; break;
                case 'item2': NavigationLine.style.left = '624px'; break;
                case 'item3': NavigationLine.style.left = '715px'; break;
                case 'item4': NavigationLine.style.left = '804px'; break;
                case 'item5': NavigationLine.style.left = '894px'; break;
                case 'item6': NavigationLine.style.left = '985px'; break;
                case 'item7': NavigationLine.style.left = '1075px'; break;
            }
        },
        navigationMouseleave(idx){
            let NavigationLine = document.getElementById('navigation-line');
            NavigationLine.style.left = this.navigationLineLeft
        },
        // 搜索
        searchMouseout(){
            let NavigationLine = document.getElementById('navigation-line');
            let left = NavigationLine.style.left.slice(0, -2);
            NavigationLine.style.left = (left - 267) + 'px'
        },
        // 网站地图
        opensitemap(){
            let siteMap = document.getElementById('siteMap');
            let siteMapShadow = document.getElementById('siteMap-shadow');
            let siteMapNavigation = document.getElementById('siteMap-navigation');
            siteMapShadow.style.display = 'block';
            siteMap.style.width = '400px';
            siteMapNavigation.style.transition = 'right 0.5s';
            siteMapNavigation.style.right = '0px'
        },
        onOpenClose(){
            this.isCloseOpen = true
            let navigationExternal = document.getElementById('navigation-external');
            let navigationContainer = document.getElementById('navigation-container');
            if(!this.isOpen){
                navigationExternal.style.transition = 'height 0.3s'
                navigationExternal.style.height = '270px'
                navigationContainer.style.display = 'block'
                this.isOpen = true
            } else {
                navigationExternal.style.transition = 'height 0.3s'
                navigationExternal.style.height = '0px'
                navigationContainer.style.display = 'none'
                this.isOpen = false
            }
        },
    },
};
</script>
<style lang="less" scoped>
@import url(../style/sub-navigation/index.css);
a{
    cursor: pointer;
}
.bgc-white{
    background-color: #fff;
}
.search-icon {
    color: #7d1118 !important;
}
.nav-search{
    display: flex;
    cursor: pointer;
    .nav-search-input{
        margin: 0 10px;
        width: 0px;
        height: 50px;
        transition: width 0.4s;
        border-radius: 10px;
        background-color: #f9efef;
    }
    .nav-search-icon{
        line-height: 50px;
        .search-icon{
            font-weight: bold;
            font-family: "iconfont" !important;
            font-size: 18px;
            font-style: normal;
            -webkit-font-smoothing: antialiased;
        }
    }
    &:hover{
        .nav-search-input{
            padding-left: 10px;
            width: 250px;
        }
        .nav-search-icon{
            line-height: 50px;
            .search-icon{
                font-size: 25px;
            }
        }
    }
}
</style>